package gr.tech.GRAttestation.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.layouts.PageLayout
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.styles.defaultText
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.grstyles.buttonColorFadeStyle
import gr.tech.GRAttestation.styles.grstyles.termsListStyle
import gr.tech.GRAttestation.styles.grstyles.termsParagraphStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Page("privacy-policy")
@Composable
fun PrivacyPage() {
    PageLayout(
        title = "Privacy Policy",
    ) {
        PrivacyPolicyScreen()
    }
}

@Composable
fun PrivacyPolicyScreen() {
    Box(Modifier.fillMaxSize().backgroundColor(Theme.MediumGreen.rgb), contentAlignment = Alignment.TopCenter) {
        Column(
            modifier = formContainer.toModifier()
        ) {

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Link(
                    path = SitePage.Dashboard.route
                ) {
                    FaCircleArrowLeft(
                        size = IconSize.XXL,
                        modifier = buttonColorFadeStyle.toModifier()
                    )
                }

                Spacer()
                H1(Modifier.toAttrs {}) {
                    Text("Privacy Policy")
                }
                Spacer()
            }


            P(attrs = Modifier.toAttrs()) {
                Text("Effective Date: 01/01/2026")
            }

            P(attrs = Modifier.toAttrs()) {
                Text("Green Rebates LLC (\"we,\" \"our,\" or \"us\") operates this portal to facilitate rebate sales reporting for the ETO Grow Light Fixture Program. This policy describes what information we collect and how we use it.")
            }

            Ol {
                Li(termsListStyle.toAttrs()) {
                    Text("Information We Collect")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("When you register and use this portal, we collect:")
                        Ul {
                            Li { Text("Account information: your name and email address.") }
                            Li { Text("Submission data: sales records, quantities, and store information you enter into attestation forms.") }
                            Li { Text("Technical information: your IP address and general information about the device and browser used to access the portal.") }
                        }
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Cookies")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("We use cookies solely to manage your login session. These cookies are necessary for the portal to function and are not used for advertising or tracking purposes.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("How We Use Your Information")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("We use the information collected to operate the portal, process rebate submissions, and comply with program and legal obligations. We do not sell or rent your personal information.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Sharing Your Information")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("We may share your information with Energy Trust of Oregon as required to administer the rebate program, or with third parties when required by law.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Data Security")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("We use industry-standard measures to protect your information. No internet transmission is completely secure, and we cannot guarantee absolute security.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Contact")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("For questions about this policy or your data, contact us at retail@greenrebates.com.")
                    }
                }
            }

            SpanText(
                text = "© 2026, Green Rebates. All Rights Reserved.",
                modifier = Modifier.defaultText().margin(leftRight = autoLength).fontSize(0.8.cssRem)
            )

            Row(
                modifier = Modifier.fillMaxWidth().gap(16.px),
                horizontalArrangement = Arrangement.Center
            ) {
                Link(
                    path = SitePage.Dashboard.route,
                    modifier = Modifier.defaultText().color(Theme.DarkGreen.rgb).fontSize(0.8.cssRem)
                ) {
                    Text("Form")
                }

                Link(
                    path = SitePage.TermsConditions.route,
                    modifier = Modifier.defaultText().color(Theme.DarkGreen.rgb).fontSize(0.8.cssRem)
                ) {
                    Text("Terms & Conditions")
                }
            }
        }
    }
}